import React from 'react';
import { observer } from 'mobx-react-lite';

import { useStores } from 'hooks/useStores';

const BusType = observer(({ busType }) => {
  const {
    dictionariesStore: { bus_types },
  } = useStores();

  if (!busType) return null;

  return (
    <tr>
      <td className="pale">Тип</td>
      <td>
        <span className="bold">
          {bus_types?.[busType]}
          {busType !== 'minibus' && ' автобус'}
        </span>
      </td>
    </tr>
  );
});

export default BusType;
